import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './snippet_actions.module.scss';
import { Toggle } from '../../../../components/toggle/Toggle';

type Props = {
  isToggled: boolean;
  handleToggleOn: () => void;
  handleToggleOff: () => void;
};

export const SnippetActions: FC<Props> = ({
  isToggled,
  handleToggleOn,
  handleToggleOff,
}) => (
  <div className={styles.container}>
    <button
      onClick={isToggled ? handleToggleOff : handleToggleOn}
      className={styles.button}
      type="button"
    >
      <span className={styles.label}>
        <FormattedMessage id="search/components/search-snippets/aside/SnippetActions.tsx" />
      </span>
      <Toggle
        checked={isToggled}
        onChange={() => {}} // Because we need onChange with "checked" prop
      />
    </button>
  </div>
);
